<template>
  <sticky-header-layout>
    <template #header>
      <div
        class="action-container d-flex justify-content-space-between flex-wrap"
      >
        <transition
          name="fade"
          mode="out-in"
        >
          <div
            v-if="hasFetchedResult"
            class="product-search-box"
          >
            <div class="d-flex">
              <label-wrapper :label="$t('table.store_id')">
                <store-selector
                  :store.sync="form.storeId"
                  :initial-search="initialSearch"
                />
              </label-wrapper>
              <label-wrapper :label="$t('table.sku')">
                <el-input
                  v-model.trim="form.skuId"
                  clearable
                  @keyup.enter.native="handleHeaderSearchClick"
                />
              </label-wrapper>
              <el-button
                class="product-search-btn"
                icon="el-icon-search"
                circle
                @click="handleHeaderSearchClick"
              />
            </div>
          </div>
          <span v-else />
        </transition>

        <div class="pagination-container">
          <el-pagination
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </template>

    <transition
      name="fade"
      mode="out-in"
    >
      <search-box
        v-if="!hasFetchedResult"
        @search="handleSearch"
      />
      <el-table
        v-loading="isLoading"
        v-else
        :data="list"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column
          v-for="column in searchListColumns"
          :key="column.type"
          :prop="column.type"
          :label="column.title || $t(`table.${column.type}`)"
          v-bind="column.custom"
        >
          <template #default="{ row, $index }">
            <template v-if="typeof row[column.type] === 'boolean'">
              {{ row[column.type] ? 'Yes' : 'No' }}
            </template>

            <template v-else-if="checkImageURL(row[column.type])">
              <img :src="row[column.type]">
            </template>

            <template v-else-if="validateURL(row[column.type])">
              <el-tooltip
                :content="row[column.type]"
                effect="light"
                placement="top-start"
              >
                <a
                  :href="row[column.type]"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <font-awesome-icon icon="external-link-alt" />
                </a>
              </el-tooltip>
            </template>

            <template v-else>
              {{ row[column.type] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </transition>
  </sticky-header-layout>
</template>

<script>
import SearchBox from './components/ProductSearchBox.vue'
import LabelWrapper from '../../components/form/LabelWrapper.vue'
import StoreSelector from '../../components/StoreSelector.vue'

import useTablePaging from '../../mixins/useTablePaging'
import { searchListColumns } from '../../const/product'
import VaderService from '../../api/vader'

import { validateURL, checkImageURL } from '../../utils/validate'

export default {
  name: 'ProductSearch',
  components: {
    SearchBox,
    LabelWrapper,
    StoreSelector,
  },
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      showSearch: true,
      hasFetchedResult: false,

      initialSearch: '',
      form: {
        storeId: '',
        skuId: '',
      },

      searchListColumns,
    }
  },
  methods: {
    // handlers
    handleHeaderSearchClick() {
      this.getList(this.form)
    },
    handleSearch({ form, keywords }) {
      this.form.storeId = form.storeId
      this.form.skuId = form.skuId
      this.initialSearch = keywords
      this.getList(this.form)
    },
    // utils
    validateURL,
    checkImageURL,
    // api call
    async getList(query) {
      this.isLoading = true
      try {
        const { data } = await VaderService.getProductByStoreSku(query)
        const { data: newList, pagination } = data
        this.list = newList.map(item => ({
          ...item,
          ...item.extra_properties,
        }))
        this.listQuery.total = parseInt(pagination.total_results, 0)
        this.hasFetchedResult = true
      } catch (error) {
        console.error(error)
        this.list = []
        this.listQuery.total = 0
        this.$message.error(error.toString())
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.product-search-box {
  .el-input {
    max-width: 148px;
  }
}
.product-search-btn {
  width: 30px;
  height: 30px;
  margin-top: 19px;
  margin-left: 4px;
}

.el-table {
  ::v-deep {
    img {
      width: 100%;
    }
  }
}
</style>
